import { Controller } from "stimulus";

export default class extends Controller
{
    connect()
    {

        let reverse = this.element.dataset["reverse"] == "true"

        if(!window.App.EDIT_MODE)
        {
            if(reverse) this.element.classList.remove("hidden");
            else this.element.classList.add("hidden");
        }
        else
        {
            if(reverse) this.element.classList.add("hidden");
            else this.element.classList.remove("hidden");
        }

        window.addEventListener("enable-edit-mode", e =>
        {
            window.App.EDIT_MODE = true;
            if(reverse) this.element.classList.add("hidden");
            else this.element.classList.remove("hidden");
        })

        window.addEventListener("disable-edit-mode", e =>
        {
            window.App.EDIT_MODE = false;
            if(reverse) this.element.classList.remove("hidden");
            else this.element.classList.add("hidden");
        })
    }
    
}